import React, { useState } from 'react'
import useAuth from '../../../hooks/useAuth'
import UtilityService from '../../../services/UtillityServices/UtilityService';
import { Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import unlockLogo from "../../../assets/img/unlock-logo.svg";
import { alertService } from '../../../services/AlertService';

const ForgotPasswordForm = () => {
  const {isLoading, forgotPassword} = useAuth();
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleForgotPasswordForm = (e) => {
    setEmail(e.target.value);
  }

  const sendEmailForgotPassword = async () => {
    if(!email || email?.trim() === ""){
        alertService.warn("Inserisci un'email", {autoClose: true});
        return;
    }
    const res = await forgotPassword({username: email});
    if(res?.Success === "Nuova password inviata con successo.") {
        setEmail('');
        navigate("/accedi");
     }
  }

  return (
    <div className='card shadow p-5 text-center email-sender-body' style={{maxWidth: '450px', border: 'none'}}>
        <div style={{margin: '0 auto', textAlign: 'center'}}>
            <img src={unlockLogo} style={{width: '72px'}} alt="lucchetto"/>
        </div>
        <span className='d-block my-2 fs-4'>Recupera password</span>
        <span className='text-muted d-block my-2'>Inserisci l'indirizzo e-mail associato al tuo account High Educational</span>
        <input type='email' value={email} placeholder='E-mail' className='form-control my-2' onChange={handleForgotPasswordForm}/>
        {
        isLoading ? 
         <Button variant={"primary"} disabled className='my-3'>
            <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
        />
          Caricamento...
        </Button> 
          :
        <button className='btn btn-primary my-3' onClick={sendEmailForgotPassword}>Invia</button>   
        }  
     </div>
  )
}

export default ForgotPasswordForm